import { ApiService } from "@edp-services/api.service";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "@edp-environments/environment";
import { EnvService } from "@edp-services/env.service";

@Injectable({
    providedIn: "root",
})
export class ApiEsService extends ApiService {
    constructor(http: HttpClient, translate: TranslateService, envService: EnvService) {
        super(http, translate, envService);
        this.apiUrl = environment.apiUrlEs;
    }
}
